import React, {useContext} from 'react';
import { useNavigate } from 'react-router-dom';

import NavItems from './NavItems';
import { categories } from '../utils/constants';
import { Context } from '../context/contextApi';

const LeftNav = () => {

  const { selectCategory, setSelectCategory, mobileMenu } = useContext(Context);
  const navigate = useNavigate();

  const clickHandler = (name, type) => {
    switch(type){
      case 'category':
        setSelectCategory(name);
        break;
      case 'home':
        setSelectCategory(name);
        break;
      case 'menu':
        return false;
    }
  }
  return (
    <div className={`md:block w-[240px] overflow-y-auto h-full py-2 bg-black absolute md:relative z-10 
    ${!mobileMenu ? 'translate-x-[-240px]' : 'translate-x-0'} md:translate-x-0 transition-all`}>
      <div className='flex px-5 flex-col'>
        {
          categories.map((item, i) => {
            return (
              <div key={i}>
                <NavItems 
                  key={i}
                  text={item.type === "home" ? "Home" : item.name}
                  icon={item.icon}
                  action={() => {
                    clickHandler(item.name, item.type);
                    navigate("/");
                  }}
                  className={`${selectCategory === item.name ? "bg-white/[0.15]" : ""}`}
                />
                {
                  item.divider && ( <hr className='my-2' /> )
                }
              </div>
            )
          })
        }
      <hr className='my-2' />
      <div className='text-white/[0.5] text-center ml-3 text-[12px]'>
        Clone by : Yasir Fazal Khan    
      </div>
      </div>

    </div>
  )
}

export default LeftNav
